module.exports = __webpack_public_path__ + "img/slide3_img2_1.412ef0c1.png";